import {AppStoreProps, ImmerStateCreator} from "./appStore";
import {getLabelConfig} from "../Utils";
import {BaseFormLabelType} from "../Types";

export interface LabelsSliceProps {
  labels: BaseFormLabelType[];
  currentTab: string | null;
  setCurrentTab: (value: string) => void;
  addLabel: (newLabel: Partial<BaseFormLabelType>) => void;
  updateLabel: (id: number, label: BaseFormLabelType) => void;
  deleteLabel: (id: number) => void;
}

export const createLabelsSlice: ImmerStateCreator<AppStoreProps, LabelsSliceProps> = (set) => {
  const setCurrentTab = (value: string) => {
    set((state) => {
      state.currentTab = value;
    });
  }

  const addLabel = (newLabel: Partial<BaseFormLabelType>) => {
    set((state) => {
      const config = getLabelConfig(state.labelType);

      if (!config) {
        throw new Error('Impossible de récupérer la configuration du type d\'étiquette ' + state.labelType + '.');
      }

      if (!state.printOptions?.size || !state.printOptions?.orientation) {
        throw new Error('Impossible de récupérer la taille et l\'orientation des étiquettes.');
      }

      const id = Date.now();

      state.labels.push({
        ...config.getDefaultLabel(state.printOptions.size, state.printOptions.orientation),
        ...newLabel,
        id
      });

      state.currentTab = id.toString();
    });
  };

  const updateLabel = (id: number, updates: BaseFormLabelType) => {
    set((state) => {
      const index = state.labels.findIndex(label => label.id === id);
      state.labels[index] = updates;
    });
  };

  const deleteLabel = (id: number) => {
    set((state) => {
      const index = state.labels.findIndex(label => label.id === id);
      state.labels.splice(index, 1);

      const previousLabel = [...state.labels].reverse().find(label => label.id < id);
      state.currentTab = previousLabel ? previousLabel.id.toString() : state.labels.length > 0 ? state.labels[0].id.toString() : '';
    });
  };

  return {
    labels: [],
    currentTab: null,
    setCurrentTab,
    addLabel,
    updateLabel,
    deleteLabel
  }
};
